<template>
<div class="confirmbox">
    <smallbutton :toplabel="title" @click="Show()" v-if="showButton" :disabled="disabled" :buttonclass="buttonclass"/>
    <linkbutton :toplabel="title" @click="Show()" v-if="showLink" :disabled="disabled"/>
    <removebutton @click="Show()" v-if="showImageButton" :disabled="disabled"/>

    <!-- MODAL -->
      <actionmodal ref="mymodal"> 
        <template v-slot:body>
            <label class="titlelabel">{{title}}</label>
            <div>
                <label :class="textclass">{{body}}</label>
            </div>
            
            <div>

                <div class="" v-if="reasonList.length>1">
                    
                    <select name="" id="" class='filterselect2' v-model="reason"  >
                        <option v-for="i in reasonList" :key="i.Name" :value="i.Name" >
                            {{i.Name}}
                        </option>
                    </select>
                </div>
                <smallbutton  @click="CloseWithReason" toplabel="OK"/>
           
                
            </div>
            <div>
              <label class="responsemessage">{{responseMessage}}</label>
            </div>
        </template>
      </actionmodal>
    </div>
</template>

<script>
import smallbutton from '../controls/button.vue'
import actionmodal from '../controls/actionmodal.vue'
import linkbutton from '../controls/linkbutton.vue'
import removebutton from '../controls/removebutton.vue'
import pay from '../../services/pay.js'
export default {
    name:'confirmrefundreturn',
    components:{
        smallbutton,
        actionmodal,
        linkbutton,
        removebutton
    },
    mixins:[pay],
    props:{
        title:{
            type:String,
            required:true
        },
        body:{
            type:String,
        },
        showButton:{
            type:Boolean,
            default:false
        },
        showImageButton:{
            type:Boolean,
            default:false,
        },
        showLink:{
            type:Boolean,
            default:false
        },
        disabled:{
          type:Boolean,
          default:false
        },
        buttonclass:{
            type:String,
            default:"button primarybutton"
        },
        isAlert:{
            type:Boolean,
            default:false
        }
    },
    data(){
        return{

            reasonList:[],
            reason:null,
            isrefund:false
        }
    },
    computed:{
    
        textclass(){
            if(this.isAlert){return 'required'}
            else{return ''}
        },
        
    },
    methods:{
        
        Show(){
            this.getreasons()
            this.$refs.mymodal.openModal()
        },
    
        async CloseWithReason(){
            if(this.reason==null || this.reason=='<Select Reason>'){
                this.responseMessage="Please select a reason"
                return
            }
            this.$emit('savereason', this.reason)
            this.$refs.mymodal.closeModal()
        },
        
    },
    mounted(){
        
    }
}
</script>

<style>
.filterselect2{
    width:200px;
    font:inherit;
    margin:10px;

}
.confirmbox{
    color:black;
}
</style>